import {
  CreateAccountFormModel,
  ForgotPasswordModel,
  LoginFormModel,
  ResendActivationFormModel,
  SetPasswordFormModel,
} from '@taxora-shared-forms/util';

export class CreateUser {
  static readonly type = '[Auth] CreateUser';
  constructor(public data: CreateAccountFormModel) {}
}

export class ActivateUser {
  static readonly type = '[Auth] ActivateUser';
  constructor(public token: string) {}
}

export class ResendActivation {
  static readonly type = '[Auth] ResendActivation';
  constructor(public data: ResendActivationFormModel) {}
}

export class SignIn {
  static readonly type = '[Auth] SignIn';
  constructor(
    public data: LoginFormModel,
    public returnUrl?: string,
  ) {}
}

export class ForgotPassword {
  static readonly type = '[Auth] ForgotPassword';
  constructor(public data: ForgotPasswordModel) {}
}

export class SetPassword {
  static readonly type = '[Auth] SetPassword';
  constructor(
    public token: string,
    public data: SetPasswordFormModel,
  ) {}
}
